import { FloatButton } from '../FloatButton/FloatButton';
import './Header.css';

export const Header = (props) => {
  const { cdn, btn } = props;

  return (
    <div className="header">
      <FloatButton cdn={cdn} type={btn} />
      <div className="header__logo">
        <img className="header__logo__img" alt="Logo abeille" src={`${cdn}pictos/logo.svg`} />
      </div>
    </div>
  );
};
